import { WifiOff, Globe, ShieldCheck, ArrowRight } from 'lucide-react';

const HIGHLIGHTS = [
  {
    icon: WifiOff,
    label: 'Offline-first',
    copy: 'Attendance and marks work without internet. Data syncs automatically when connectivity returns.',
  },
  {
    icon: Globe,
    label: 'Nepal & India',
    copy: 'One platform for both countries — Bikram Sambat dates, NPR/INR, and local payment gateways.',
  },
  {
    icon: ShieldCheck,
    label: 'Never lose your work',
    copy: 'Every edit autosaves locally. A refresh is always safe — your data survives any network interruption.',
  },
] as const;

export function LoginHero() {
  return (
    <section className="login-hero" aria-label="Value proposition">
      <p className="login-hero-kicker">School operations platform</p>
      <h1>Reliable school management for Nepal and India.</h1>
      <p className="login-hero-tagline">
        Attendance, fees, marks, and communication — designed for low-connectivity schools and budget phones.
      </p>

      <div className="login-hero-visual" aria-hidden="true">
        <div className="login-hero-phone">
          <div className="login-hero-phone-screen">
            <div className="login-hero-phone-header">
              <span className="login-hero-phone-dot" />
              <span className="login-hero-phone-time">9:41</span>
            </div>
            <div className="login-hero-phone-body">
              <div className="login-hero-phone-class">Grade 5 · Section A</div>
              <div className="login-hero-phone-date">Baishakh 8, 2081</div>
              <div className="login-hero-phone-students">
                <span className="login-hero-phone-student">Aarav Sharma</span>
                <span className="login-hero-phone-status status-present">P</span>
              </div>
              <div className="login-hero-phone-students">
                <span className="login-hero-phone-student">Sita Gurung</span>
                <span className="login-hero-phone-status status-absent">A</span>
              </div>
              <div className="login-hero-phone-students">
                <span className="login-hero-phone-student">Bikash Thapa</span>
                <span className="login-hero-phone-status status-late">L</span>
              </div>
              <div className="login-hero-phone-footer">
                <span className="login-hero-phone-sync">● Synced</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="login-hero-grid" aria-label="Key differentiators">
        {HIGHLIGHTS.map((highlight) => {
          const Icon = highlight.icon;
          return (
            <article key={highlight.label} className="login-hero-card">
              <Icon size={20} className="login-hero-card-icon" aria-hidden="true" />
              <p className="login-hero-card-label">{highlight.label}</p>
              <p className="login-hero-card-copy">{highlight.copy}</p>
            </article>
          );
        })}
      </div>

      <div className="login-hero-trust" aria-label="Login benefits">
        <span>OTP sign-in</span>
        <span className="login-hero-trust-sep" aria-hidden="true">·</span>
        <span>Role-based access</span>
        <span className="login-hero-trust-sep" aria-hidden="true">·</span>
        <span>Offline-ready</span>
        <span className="login-hero-trust-sep" aria-hidden="true">·</span>
        <span>Free to start</span>
        <ArrowRight size={14} aria-hidden="true" />
      </div>
    </section>
  );
}